/**
 * Hallow's search service (OpenSearch behind CloudFront). Replaces Elastic App
 * Search behind the `web_search_service` flag. Optional Doppler override for
 * previews; otherwise prod/dev by build environment, matching
 * `ELASTIC_SEARCH_DIRECTORY`.
 */
export const URL_SEARCH_SERVICE =
  process.env.DOPPLER_PUBLIC_SEARCH_SERVICE_URL ??
  (process.env.NODE_ENV === "production"
    ? "https://search.hallow.app"
    : "https://search-dev.hallow.app");
